export default "__VITE_ASSET__BWd85ZvP__"